import { FieldValues } from 'react-hook-form';
import { BulkInputFilterValidationResult } from '../filters/bulk-input-filter/types';

// Function to normalize LinkedIn URLs for comparison
const normalizeUrl = (url: string): string => {
  let normalized = url.toLowerCase().trim();

  normalized = normalized.replace(/^https?:\/\//, '');
  normalized = normalized.replace(/^www\./, '');
  normalized = normalized.replace(/\/$/, '');

  return normalized;
};

export const bulkUrlValidation = (
  inputs: FieldValues,
  patterns: RegExp[]
): BulkInputFilterValidationResult => {
  const result: BulkInputFilterValidationResult = {};
  Object.keys(inputs).forEach((key) => {
    const values = inputs[key]
      ?.split('\n')
      .map((v: string) => v.trim())
      .filter(Boolean);

    const invalids = values?.filter(
      (val: string) =>
        !patterns.some((regex) => regex.test(decodeURIComponent(val)))
    );

    const duplicates = findDuplicateEntries(values || []);

    result[key] = { invalids, duplicates };
  });

  return result;
};

// Function to find duplicate entries that represent the same entity
export const findDuplicateEntries = (values: string[]): string[] => {
  const seen = new Map<string, string[]>();
  const duplicates: string[] = [];

  for (const value of values) {
    const normalized = normalizeUrl(value);

    if (seen.has(normalized)) {
      const existingValues = seen.get(normalized);
      if (existingValues) {
        existingValues.push(value);
      }
    } else {
      seen.set(normalized, [value]);
    }
  }

  // Collect all duplicate values (skip the first occurrence)
  seen.forEach((valueGroup) => {
    if (valueGroup.length > 1) {
      // Add all occurrences except the first one
      duplicates.push(...valueGroup.slice(1));
    }
  });

  return duplicates;
};
